<template>
  <div id="app">
    <NavBar></NavBar>
    <!-- <NavBar :newVal="newVal"></NavBar> -->
    <keep-alive>
      <router-view/>
    </keep-alive>
    <Bottom></Bottom>
  </div>
</template>

<script>
import NavBar from 'components/common/navbar.vue'
import Bottom from 'components/common/bottom.vue'

export default {
  components: {
    NavBar,
    Bottom
  },
  data () {
    return {
      // showBtm: true,
      // newVal: ''
    }
  },
  watch: {
    // '$route.path': function (newVal, oldVal) {
    //   this.newVal = newVal
    //   if (newVal === '/developer') {
    //     this.showBtm = false
    //   } else {
    //     this.showBtm = true
    //   }
    // }
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
html,body{
  margin: 0;
  padding: 0;
  min-width: 1400px;
}
ul,li{
  list-style: none;
}
</style>
